import React from 'react';

export default function Astron() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_5187_40988)'>
        <path
          d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
          fill='url(#paint0_linear_5187_40988)'
        />
        <g filter='url(#filter0_dd_5187_40988)'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M10.8581 15.9788C8.1652 21.465 5.97913 25.9745 6.00015 25.9999C6.02103 26.0253 13.1224 22.6739 21.7807 18.5524C30.439 14.4309 34.0263 12.54 33.9999 12.5138C33.9734 12.4876 29.5979 14.1004 29.5979 14.1004C29.5979 14.1004 21.6601 16.5872 21.5856 16.557C21.511 16.5267 20.1989 14.1381 18.6699 11.2489C17.1409 8.35972 15.8593 5.99772 15.822 6C15.7847 6.00215 13.5509 10.4927 10.8581 15.9788ZM17.1532 14.9465C17.8462 16.3227 18.3913 17.4702 18.3646 17.4965C18.2679 17.5924 13.0406 19.4069 12.9927 19.3613C12.9283 19.2999 15.7329 12.4499 15.8238 12.4468C15.8619 12.4456 16.4602 13.5704 17.1532 14.9465ZM21.4936 22.771C20.7717 23.3385 20.1767 23.8484 20.1714 23.9037C20.166 23.9591 21.016 24.0045 22.0602 24.0045C23.3781 24.0045 23.9588 23.9582 23.9588 23.8531C23.9588 23.7173 22.8899 21.7053 22.8305 21.7292C22.817 21.7348 22.2155 22.2035 21.4936 22.771Z'
            fill='url(#paint1_linear_5187_40988)'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_dd_5187_40988'
          x='-24'
          y='-20.1015'
          width='88'
          height='80'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.866667 0 0 0 0 0.254902 0 0 0 0 0.254902 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5187_40988'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_5187_40988'
            result='effect2_dropShadow_5187_40988'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_5187_40988'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_5187_40988'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#E14443' />
          <stop offset='1' stop-color='#BC2F2E' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5187_40988'
          x1='5.78366'
          y1='1.89066'
          x2='18.0646'
          y2='27.0918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_5187_40988'>
          <path
            d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
